import { render, staticRenderFns } from "./PodcastDetails.vue?vue&type=template&id=474664e4&"
import script from "./PodcastDetails.vue?vue&type=script&lang=ts&"
export * from "./PodcastDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports